import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'
import CircularIcon from '../CircularIcon'
import TextShowMore from '../TextShowMore'


import styles from './styles'


const decorators = [
  memoized,
]

function CircularFeature(props) {
  const { icon, title, text, textShowMore } = props

  return (
    <div className="container">
      {icon
      && <CircularIcon icon={icon} />
      }
      <p className="title" dangerouslySetInnerHTML={{ __html: title}}></p>
      <p className="text">{text}</p>
      <style jsx>{styles}</style>
    </div>
  )
}

CircularFeature.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  textShowMore: TextShowMore.propTypes
}

CircularFeature.defaultProps = {
  icon: '',
}

CircularFeature = chainDecorators(decorators, CircularFeature)

export default CircularFeature
